import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../utils/util';

@Pipe({name: 'cpfCnpjPixMask'})
export class CpfCnpjPixPipe implements PipeTransform {

	transform(str: string) {
		if (str) {
			return Util.maskCpfCnpjPix(str);
		}
		return str;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/cpf-cnpj-pix.pipe.ts